import React, { useState } from 'react'
import Sidebar from './appincludes/sidebar'
import Footer from './appincludes/footer'
import Mainheader from './appincludes/mainheader'
import Rightsidebar from './appincludes/rightsidebar'
import SideBarTriggerContext from '../../context/SideBarTriggerContext';

function Applayout({ children }) {
  const [triggerSideBar, setTriggerSideBar] = useState(false);
    return (
        <SideBarTriggerContext.Provider value={{ triggerSideBar, setTriggerSideBar }}>
          <div class="page-wrapper">
            <div class="page-body-wrapper">
              <Mainheader />
              <Sidebar />
              <Rightsidebar />
              <div class="page-body">
                  {children}
              </div>
              <Footer />
            </div>
          </div>
        </SideBarTriggerContext.Provider>
    )
}

export default Applayout
